// extracted by mini-css-extract-plugin
export default {"orgSettingsListItem":"OrganizationSettingsListItem_orgSettingsListItem__Cqp7K","textContent":"OrganizationSettingsListItem_textContent__4KG+A"};